module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/tile_kidsbirthday-d7fc0b750d34ccec01901de73e6cb3db.jpg";